import { Controller, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { InputPercentage } from '@root/shared/ui-kit'

import { TradeSettingsAutoToggle } from './common/trade-settings-auto-toggle'

import type { CommonValues } from '../../common'
import type { ClassNameProps } from '@root/shared/react'

type Props = {} & ClassNameProps

export const TradeSettingsFormSlippage: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation()

  const { control } = useFormContext<CommonValues>()

  return (
    <Root className={className}>
      <Controller
        control={control}
        name="slippage"
        rules={{
          required: t('validation.required'),
        }}
        render={({ field, fieldState }) => (
          <InputPercentage
            startContent={<Label>{t('trade.slippage')}</Label>}
            withStartSeparator
            value={field.value}
            onChange={(value) => field.onChange(value.value)}
            placeholder={t('trade-settings.enter-slippage')}
            error={fieldState.error?.message}
          />
        )}
      />
      <Controller
        control={control}
        name="slippageAuto"
        render={({ field }) => (
          <TradeSettingsAutoToggle
            checked={field.value}
            onChange={field.onChange}
          />
        )}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
`

const Label = styled.span`
  color: var(--text-11);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
